import { ReactNode, useMemo } from 'react';

import get from 'lodash/get';
import { useFormContext } from 'react-hook-form';

export const useErrorMessage = (name: string, label?: ReactNode) => {
  const { formState } = useFormContext();

  return useMemo(() => {
    const error = get(formState.errors, name);

    if (!error || !error.message) return undefined;

    const message = error.message;

    if (typeof message === 'string' && typeof name === 'string') {
      const labelText = typeof label === 'string' ? label : name;
      try {
        return message.replace(name, labelText);
      } catch (e) {
        return message;
      }
    }
    return typeof message === 'string' ? message : 'Field validation failed';
  }, [formState.errors, name, label]);
};
